'use client';
import DarkHeader from '@/components/dark-header/dark-header.react-component';

export function Header() {
    const navigationItems = [
        {
            label: 'Subscription',
            anchorElementId: 'subscription',
        },
        {
            label: 'Tips',
            anchorElementId: 'tips',
        },
        {
            label: 'Quiz',
            anchorElementId: 'quiz',
        },
        {
            label: 'Behind the scenes',
            anchorElementId: 'behind-the-scenes',
        },
    ];
    return (
        <header>
            <DarkHeader showLanguageSelector={false} navigationItems={navigationItems} />
        </header>
    );
}
